
import { ExtraRequestDetailsController } from "./controllers/extraRequestDetailsController";
import './templates/extraRequestDetails.scss';
import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';


export function extraRequestDetailsDirective(): ng.IDirective {
    return <ng.IDirective>{
        template: require("./templates/extraRequestDetails.html"),
        controller: ExtraRequestDetailsController,
        controllerAs: "vm",
        bindToController: {
            requestDetailEdit: "=",
            attachmentFormData:"=",
            isLoading: "=",
            isValid: "=",
            requestAllDetails : "="
       },
        scope: true
    }
}

angular
    .module("deliveryCreate.app")
    .directive("extraRequestDetails", extraRequestDetailsDirective);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/extraRequestDetails/extraRequestDetailsDirective.ts
 **/